/**
 * Spine sets `window.fabric.persistedState.emitRegisterStart = true` when Sign Up
 * is clicked, as a backup for the `registration { kind: 'start' }` message (the
 * message bus does not replay, so a click before we subscribe is otherwise lost).
 *
 * `window.fabric` is typed as always present, but it is only there when spine is,
 * hence the optional chaining.
 */
export const hasPendingRegisterStart = (): boolean =>
  window.fabric?.persistedState?.emitRegisterStart === true;

export const clearPendingRegisterStart = () => {
  const persistedState = window.fabric?.persistedState;

  if (persistedState) {
    persistedState.emitRegisterStart = false;
  }
};
